import React from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import { throttle } from 'lodash';

import ImmutablePropTypes from 'react-immutable-proptypes';

const comparisions = Map({
    'eq': '==',
    'ne': '!=',
    'lte': '<',
    'gt': '>',
    'gte': '>='
});

function getConstraints(permission, grant) {
    if (grant && grant.size > 0) {
        return grant;
    }

    if (permission.get('contextAttributes', List()).size > 0) {
        return List([ Map() ]);
    }

    return List();
}

class PermissionEditForm extends React.Component {
    static propTypes = {
        permission: ImmutablePropTypes.map,
        disabled: PropTypes.boolean,
        grant: PropTypes.map,
        onChange: PropTypes.func
    };

    static defaultProps = {
        grants: List(),
        onChange: () => {},
        disabled: false
    };

    constructor(props, context) {
        super(props, context);
        const { permission, grant } = this.props;
        this.state = {
            constraints: getConstraints(permission, grant)
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        const { permission, grant } = props;
        if (grant !== this.props.grant) {
            this.setState({
                constraints: getConstraints(permission, grant)
            });
        }
    }

    onChange(constraints) {
        this.props.onChange(constraints);
    }

    setConstraint(key, field, value) {
        let { constraints } = this.state;
        constraints = constraints.update(key, c => c.set(field, value));

        this.setState({
            constraints
        });

        this.onChange(constraints);
    }

    addConstraint() {
        let { constraints } = this.state;
        this.setState({
            constraints: constraints.push(Map())
        });
    }

    removeConstraint() {
        let { constraints } = this.state;
        if (constraints.size < 2) {
            return false;
        }
        constraints = constraints.pop();

        this.setState({
            constraints
        });

        this.onChange(constraints);
    }

    render() {
        const { permission, disabled } = this.props;
        const { constraints } = this.state;
        const ca = permission.get('contextAttributes', List());

        return (
            <ul className="constraints-edit-form">
                { constraints.map((constraint, key) => (
                    <li>
                        <div className="constraints-edit-form__inputs">
                            <div className="element">
                                <select
                                    disabled={ disabled }
                                    value={ constraint.get('field') }
                                    onChange={ e => this.setConstraint(key, 'field', e.target.value) }
                                >
                                    <option value={ void 0 }>Select value</option>
                                    {
                                        ca.map(
                                            _a => <option value={ _a.get('id') }>{ _a.get('name') }</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="element">
                                <select
                                    disabled={ disabled }
                                    value={ constraint.get('type') }
                                    onChange={ e => this.setConstraint(key, 'type', e.target.value) }
                                >
                                    <option value={ void 0 }>Select type</option>
                                    {
                                        comparisions.map(
                                            (c, cKey) => <option value={ cKey }>{ c }</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="element">
                                <input
                                    disabled={ disabled }
                                    value={ constraint.get('value') }
                                    type="text"
                                    onChange={ e => this.setConstraint(key, 'value', e.target.value) }
                                />
                            </div>
                        </div>
                        { key === constraints.size - 1 ? (
                            <div className="menu">
                                <button
                                    disabled={ disabled }
                                    onClick={ this.addConstraint.bind(this)}
                                    className="btn"
                                    type="button"
                                >
                                    +
                                </button>
                                <button
                                    disabled={ disabled }
                                    onClick={ this.removeConstraint.bind(this)}
                                    className="btn"
                                    type="button"
                                >
                                    -
                                </button>
                            </div>
                        ) : void 0 }
                    </li>
                )) }
            </ul>
        );
    }
}

export default PermissionEditForm;
